import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-016ab20c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import NavBar from '../components/NavBar.vue'
    import SiteFooter from '../components/SiteFooter.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewContainer',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(SiteFooter)
  ]))
}
}

})